/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Confirmation_ReferenceInputs */

const en_case_payment_validation_confirmation_reference = /** @type {(inputs: Case_Payment_Validation_Confirmation_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The confirmation does not match a payment in this plan.`)
};

const pt_br2_case_payment_validation_confirmation_reference = /** @type {(inputs: Case_Payment_Validation_Confirmation_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A confirmação não corresponde a um pagamento deste plano.`)
};

/**
* | output |
* | --- |
* | "The confirmation does not match a payment in this plan." |
*
* @param {Case_Payment_Validation_Confirmation_ReferenceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_confirmation_reference = /** @type {((inputs?: Case_Payment_Validation_Confirmation_ReferenceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Confirmation_ReferenceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_confirmation_reference(inputs)
	return pt_br2_case_payment_validation_confirmation_reference(inputs)
});